import React from "react";
import clsx from "clsx";
import styles from './style.module.css';
import { IconProviderProps } from "./IconProvider.types";
// import { ADD_CREDIT_CARD } from "../../static/index.js";


const IconProviderSvgModifier: React.FC<IconProviderProps> = ({Icon ,size ,style , className}: IconProviderProps) => {

    return <div  className={clsx(styles[`size${size}`], styles.fucking , className)} style={style && style}>
        <Icon />
    </div>;
};

export default IconProviderSvgModifier;

